export interface BlogPostContent {
  type: 'paragraph' | 'heading' | 'image' | 'quote' | 'list';
  text?: string;
  src?: string;
  alt?: string;
  caption?: string;
  attribution?: string;
  items?: string[];
}

export interface BlogPost {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  date: string;
  category: string;
  image: string;
  imageAlt?: string;
  imageCaption?: string;
  sources?: { title: string; url: string }[];
  relatedSlugs?: string[];
  readTime: string;
  featured?: boolean;
  series?: string;
  author?: string;
  // Direct, one-or-two-sentence answer to the question in the title. Used for
  // the "Quick Answer" lead block and FAQPage JSON-LD on question-form posts.
  tldr?: string;
  content?: BlogPostContent[];
}

export const CATEGORIES = ['All', 'Updates', 'Geography', 'Behind the Scenes', 'Community', 'Team Building', 'Education'];
